var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 446,
    height: 168,
    viewBox: "0 0 446 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.874 2.17627H438.654H445.318V167.692H438.654H437.874H0V2.17627H437.874Z",
    fill: "#EAF4F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.411 55.8193H37.1445V71.954H108.411V55.8193Z",
    fill: "#3AB8CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M195.727 55.8193H124.461V71.954H195.727V55.8193Z",
    fill: "#3AB8CF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M318.544 55.8193H247.721V71.954H318.544V55.8193Z",
    fill: "#3AB8CF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M409.655 55.8193H338.832V71.954H409.655V55.8193Z",
    fill: "#3AB8CF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.411 38.397H37.1445V54.5304H108.411V38.397Z",
    fill: "#3AB8CF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M195.729 38.397H124.463V54.5304H195.729V38.397Z",
    fill: "#3AB8CF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M318.544 38.397H247.721V54.5304H318.544V38.397Z",
    fill: "#3AB8CF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M409.657 38.397H338.834V54.5304H409.657V38.397Z",
    fill: "#3AB8CF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40951 2.17676H0V167.691H4.40951V2.17676Z",
    fill: "#DFE9EC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0474 2.17676H17.6367V167.691H22.0474V2.17676Z",
    fill: "#DFE9EC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6829 2.17676H35.2734V167.691H39.6829V2.17676Z",
    fill: "#DFE9EC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3197 2.17676H52.9102V167.691H57.3197V2.17676Z",
    fill: "#DFE9EC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9544 2.17676H70.5449V167.691H74.9544V2.17676Z",
    fill: "#DFE9EC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5933 2.17676H88.1836V167.691H92.5933V2.17676Z",
    fill: "#DFE9EC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M110.228 2.17676H105.818V167.691H110.228V2.17676Z",
    fill: "#DFE9EC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M127.865 2.17676H123.455V167.691H127.865V2.17676Z",
    fill: "#DFE9EC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M145.502 2.17676H141.092V167.691H145.502V2.17676Z",
    fill: "#DFE9EC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M163.137 2.17676H158.729V167.691H163.137V2.17676Z",
    fill: "#DFE9EC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M180.774 2.17676H176.365V167.691H180.774V2.17676Z",
    fill: "#DFE9EC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M198.41 2.17676H194V167.691H198.41V2.17676Z",
    fill: "#DFE9EC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M216.046 2.17676H211.637V167.691H216.046V2.17676Z",
    fill: "#DFE9EC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M233.682 2.17676H229.273V167.691H233.682V2.17676Z",
    fill: "#DFE9EC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M251.32 2.17676H246.91V167.691H251.32V2.17676Z",
    fill: "#DFE9EC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M268.956 2.17676H264.547V167.691H268.956V2.17676Z",
    fill: "#DFE9EC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M286.591 2.17676H282.182V167.691H286.591V2.17676Z",
    fill: "#DFE9EC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M304.227 2.17676H299.818V167.691H304.227V2.17676Z",
    fill: "#DFE9EC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M321.864 2.17676H317.455V167.691H321.864V2.17676Z",
    fill: "#DFE9EC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M339.502 2.17676H335.092V167.691H339.502V2.17676Z",
    fill: "#DFE9EC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M357.137 2.17676H352.729V167.691H357.137V2.17676Z",
    fill: "#DFE9EC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M374.774 2.17676H370.365V167.691H374.774V2.17676Z",
    fill: "#DFE9EC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M392.412 2.17676H388.002V167.691H392.412V2.17676Z",
    fill: "#DFE9EC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M410.046 2.17676H405.637V167.691H410.046V2.17676Z",
    fill: "#DFE9EC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M427.682 2.17676H423.273V167.691H427.682V2.17676Z",
    fill: "#DFE9EC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M445.318 2.17676H440.91V167.691H445.318V2.17676Z",
    fill: "#DFE9EC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M445.319 0H0V4.35594H445.319V0Z",
    fill: "#DFE9EC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M445.319 17.4224H0V21.7783H445.319V17.4224Z",
    fill: "#DFE9EC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M445.319 34.8457H0V39.2004H445.319V34.8457Z",
    fill: "#DFE9EC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M445.319 52.2681H0V56.624H445.319V52.2681Z",
    fill: "#DFE9EC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M445.319 69.6904H0V74.0464H445.319V69.6904Z",
    fill: "#DFE9EC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M445.319 87.1133H0V91.469H445.319V87.1133Z",
    fill: "#DFE9EC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.452 99.3086H424.181H430.397V167.692H424.181H423.452H14.9238V99.3086H423.452Z",
    fill: "#DFE9EC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9238 99.3086H78.6889V153.816H68.6589V109.911H24.9515V153.816H14.9238V99.3086Z",
    fill: "#258EA1"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6601 109.912H24.9531V153.814H68.6601V109.912Z",
    fill: "#D3DBDE"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4343 120.141H17.9922V135.148H21.4343V120.141Z",
    fill: "#F2D166"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6211 120.141H72.1777V135.148H75.6211V120.141Z",
    fill: "#F2D166"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6354 118.099H24.9766V118.97H68.6354V118.099Z",
    fill: "#C0C9CC"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6354 126.81H24.9766V127.681H68.6354V126.81Z",
    fill: "#C0C9CC"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6354 135.521H24.9766V136.393H68.6354V135.521Z",
    fill: "#C0C9CC"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6354 144.233H24.9766V145.103H68.6354V144.233Z",
    fill: "#C0C9CC"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6354 152.944H24.9766V153.815H68.6354V152.944Z",
    fill: "#C0C9CC"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.7773 99.3086H148.542V153.816H138.512V109.911H94.805V153.816H84.7773V99.3086Z",
    fill: "#258EA1"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M138.514 109.912H94.8066V153.814H138.514V109.912Z",
    fill: "#D3DBDE"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2878 120.141H87.8457V135.148H91.2878V120.141Z",
    fill: "#F2D166"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M145.474 120.141H142.031V135.148H145.474V120.141Z",
    fill: "#F2D166"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M138.489 118.099H94.8301V118.97H138.489V118.099Z",
    fill: "#C0C9CC"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M138.489 126.81H94.8301V127.681H138.489V126.81Z",
    fill: "#C0C9CC"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M138.489 135.521H94.8301V136.393H138.489V135.521Z",
    fill: "#C0C9CC"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M138.489 144.233H94.8301V145.103H138.489V144.233Z",
    fill: "#C0C9CC"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M138.489 152.944H94.8301V153.815H138.489V152.944Z",
    fill: "#C0C9CC"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.631 99.3086H218.396V153.816H208.366V109.911H164.658V153.816H154.631V99.3086Z",
    fill: "#258EA1"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M208.366 109.912H164.658V153.814H208.366V109.912Z",
    fill: "#D3DBDE"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M161.142 120.141H157.699V135.148H161.142V120.141Z",
    fill: "#F2D166"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M215.327 120.141H211.885V135.148H215.327V120.141Z",
    fill: "#F2D166"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M208.342 118.099H164.684V118.97H208.342V118.099Z",
    fill: "#C0C9CC"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M208.342 126.81H164.684V127.681H208.342V126.81Z",
    fill: "#C0C9CC"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M208.342 135.521H164.684V136.393H208.342V135.521Z",
    fill: "#C0C9CC"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M208.342 144.233H164.684V145.103H208.342V144.233Z",
    fill: "#C0C9CC"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M208.342 152.944H164.684V153.815H208.342V152.944Z",
    fill: "#C0C9CC"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.484 99.3086H288.249V153.816H278.219V109.911H234.512V153.816H224.484V99.3086Z",
    fill: "#258EA1"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M278.221 109.912H234.514V153.814H278.221V109.912Z",
    fill: "#D3DBDE"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M230.995 120.141H227.553V135.148H230.995V120.141Z",
    fill: "#F2D166"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M285.182 120.141H281.738V135.148H285.182V120.141Z",
    fill: "#F2D166"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M278.196 118.099H234.537V118.97H278.196V118.099Z",
    fill: "#C0C9CC"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M278.196 126.81H234.537V127.681H278.196V126.81Z",
    fill: "#C0C9CC"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M278.196 135.521H234.537V136.393H278.196V135.521Z",
    fill: "#C0C9CC"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M278.196 144.233H234.537V145.103H278.196V144.233Z",
    fill: "#C0C9CC"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M278.196 152.944H234.537V153.815H278.196V152.944Z",
    fill: "#C0C9CC"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.34 99.3086H358.105V153.816H348.075V109.911H304.367V153.816H294.34V99.3086Z",
    fill: "#258EA1"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M348.076 109.912H304.369V153.814H348.076V109.912Z",
    fill: "#D3DBDE"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M300.85 120.141H297.408V135.148H300.85V120.141Z",
    fill: "#F2D166"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M355.036 120.141H351.594V135.148H355.036V120.141Z",
    fill: "#F2D166"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M348.05 118.099H304.393V118.97H348.05V118.099Z",
    fill: "#C0C9CC"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M348.05 126.81H304.393V127.681H348.05V126.81Z",
    fill: "#C0C9CC"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M348.05 135.521H304.393V136.393H348.05V135.521Z",
    fill: "#C0C9CC"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M348.05 144.233H304.393V145.103H348.05V144.233Z",
    fill: "#C0C9CC"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M348.05 152.944H304.393V153.815H348.05V152.944Z",
    fill: "#C0C9CC"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M364.193 99.3086H427.958V153.816H417.928V109.911H374.221V153.816H364.193V99.3086Z",
    fill: "#258EA1"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M417.929 109.912H374.221V153.814H417.929V109.912Z",
    fill: "#D3DBDE"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M370.705 120.141H367.262V135.148H370.705V120.141Z",
    fill: "#F2D166"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M424.889 120.141H421.447V135.148H424.889V120.141Z",
    fill: "#F2D166"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M417.905 118.099H374.246V118.97H417.905V118.099Z",
    fill: "#C0C9CC"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M417.905 126.81H374.246V127.681H417.905V126.81Z",
    fill: "#C0C9CC"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M417.905 135.521H374.246V136.393H417.905V135.521Z",
    fill: "#C0C9CC"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M417.905 144.233H374.246V145.103H417.905V144.233Z",
    fill: "#C0C9CC"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M417.905 152.944H374.246V153.815H417.905V152.944Z",
    fill: "#C0C9CC"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.452 154.066H424.181H430.397V167.69H424.181H423.452H14.9238V154.066H423.452Z",
    fill: "#A9AAAB"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433.318 90.2051L445.319 102.176V167.69H81.7247L12.5762 98.7032L433.318 90.2051Z",
    fill: "#808080"
  }))), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M433.178 90.0029H12.1406V99.2214H433.178V90.0029Z",
    fill: "#F7FBFA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.56acc452dbf9aea7c3fc137d9d58bb89.svg";
export { ForwardRef as ReactComponent };